/**
 * @desc 导入sku报价信息修改
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/importUpdateSupplierQuotation`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
